import { render, staticRenderFns } from "./product_design_statistics.vue?vue&type=template&id=3d5ba173&scoped=true"
import script from "./product_design_statistics.vue?vue&type=script&lang=js"
export * from "./product_design_statistics.vue?vue&type=script&lang=js"
import style0 from "./product_design_statistics.vue?vue&type=style&index=0&id=3d5ba173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ba173",
  null
  
)

export default component.exports